/* Sticky table of contents for Witch, Please! blog articles (Berenice, 2026-11-02, design 1 "Cream & gold").
   Lists the H2s in the article body. Key Takeaways and a written "Table of Contents" heading are left out.
   Phones and tablets: a button at the bottom left opens the list. 1280px and wider: the list sits beside the article.
   Styles: sections/wp-article.liquid, the #wp-article .wtoc rules. */
(function () {
  'use strict';
  function init() {
    const root = document.getElementById('wp-article');
    if (!root || root.querySelector('.wtoc-root')) return;
    const ab = root.querySelector('.abody');
    if (!ab) return;
    const hs = [...ab.querySelectorAll('h2')].filter(h => !/^(key takeaways|table of contents)$/i.test(h.textContent.trim()));
    if (hs.length < 2) return;

    // Headings without an id get one made from their text, so links and shared addresses work.
    const used = new Set([...document.querySelectorAll('[id]')].map(e => e.id));
    hs.forEach(h => {
      if (h.id) return;
      const s = h.textContent.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
      let id = s, k = 2;
      while (used.has(id)) id = s + '-' + k++;
      h.id = id;
      used.add(id);
    });

    const esc = s => s.replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
    const num = i => String(i + 1).padStart(2, '0');
    const ICON = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle class="d" cx="2.6" cy="3.4" r="1.6"/><circle class="d" cx="2.6" cy="8" r="1.6"/><circle class="d" cx="2.6" cy="12.6" r="1.6"/><rect class="b" x="6.4" y="2.6" width="8.6" height="1.6" rx=".8"/><rect class="b" x="6.4" y="7.2" width="8.6" height="1.6" rx=".8"/><rect class="b" x="6.4" y="11.8" width="8.6" height="1.6" rx=".8"/></svg>';
    const X = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
    const wrap = document.createElement('div');
    wrap.className = 'wtoc-root';
    wrap.innerHTML = '<button type="button" class="wtoc-open" aria-controls="wtoc-panel" aria-expanded="false">' + ICON + '<span>Table of Contents</span></button>'
      + '<div class="wtoc-bd"></div>'
      + '<nav class="wtoc" id="wtoc-panel" aria-label="Table of Contents"><div class="wtoc-head"><p class="wtoc-title">Table of Contents</p>'
      + '<button type="button" class="wtoc-close" aria-label="Close table of contents">' + X + '</button></div>'
      + '<ol>' + hs.map((h, i) => '<li><a href="#' + esc(h.id) + '"><span class="n">' + num(i) + '</span><span class="t">' + esc(h.textContent.trim()) + '</span></a></li>').join('') + '</ol></nav>';
    root.appendChild(wrap);

    const pill = wrap.querySelector('.wtoc-open'), panel = wrap.querySelector('.wtoc'), bd = wrap.querySelector('.wtoc-bd');
    const list = panel.querySelector('ol'), links = [...panel.querySelectorAll('a')];
    const railMQ = matchMedia('(min-width: 1280px)');
    const setOpen = (on, focus) => {
      wrap.classList.toggle('is-open', on);
      pill.setAttribute('aria-expanded', String(on));
      if (on) {
        const a = links.find(x => x.classList.contains('is-on'));
        if (a) list.scrollTop = Math.max(0, a.parentNode.offsetTop - list.clientHeight / 2);
        if (focus) panel.querySelector('.wtoc-close').focus({preventScroll: true});
      } else if (focus) pill.focus({preventScroll: true});
    };
    pill.addEventListener('click', () => setOpen(!wrap.classList.contains('is-open'), true));
    bd.addEventListener('click', () => setOpen(false, false));
    panel.querySelector('.wtoc-close').addEventListener('click', () => setOpen(false, true));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && wrap.classList.contains('is-open')) setOpen(false, true); });

    // Article photos load lazily and have no set height, so they grow during the scroll and push the heading down.
    // Load the photos on the way, then keep correcting until the heading stays put. Any scroll by the reader stops it.
    let lock = -1, lockY = 0, settling = false, settleRun = 0;
    const endSettle = () => { settling = false; wrap.removeAttribute('data-settling'); };
    const stopSettle = e => { if (settling && !(e && e.target && wrap.contains(e.target))) { endSettle(); settleRun++; } };
    ['wheel', 'touchstart', 'keydown'].forEach(ev => addEventListener(ev, stopSettle, {passive: true}));
    const jump = i => {
      const h = hs[i], t0 = h.getBoundingClientRect().top, lo = Math.min(0, t0) - 200, hi = Math.max(innerHeight, t0 + innerHeight) + 200;
      ab.querySelectorAll('img[loading="lazy"]').forEach(img => { const r = img.getBoundingClientRect(); if (r.bottom >= lo && r.top <= hi) img.loading = 'eager'; });
      lock = i;
      settling = true;
      wrap.setAttribute('data-settling', '');
      const run = ++settleRun;
      h.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      history.replaceState(null, '', '#' + h.id);
      const want = () => parseFloat(getComputedStyle(h).scrollMarginTop) || 0;
      let lastY = scrollY, still = 0, okSince = 0;
      const begin = performance.now();
      const tick = now => {
        if (run !== settleRun) return;
        const moved = Math.abs(scrollY - lastY) > .5;
        lastY = scrollY;
        still = moved ? 0 : still + 1;
        if (still >= 3) {
          const off = h.getBoundingClientRect().top - want();
          if (Math.abs(off) > 2) { window.scrollTo(0, scrollY + off); lastY = scrollY; okSince = 0; still = 0; }
          else if (!okSince) okSince = now;
          else if (now - okSince > 700) { endSettle(); lockY = scrollY; onScroll(); return; }
        }
        if (now - begin > 6000) { endSettle(); lockY = scrollY; onScroll(); return; }
        lockY = scrollY;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    links.forEach((a, i) => a.addEventListener('click', e => { e.preventDefault(); setOpen(false, false); jump(i); }));

    const start = root.querySelector('.fmat') || ab, bio = root.querySelector('.bio') || ab;
    const endRail = root.querySelector('.rel') || root.querySelector('.aback') || bio;
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = innerHeight, line = Math.min(vh * .3, 260);
      let cur = -1;
      hs.forEach((h, i) => { if (h.getBoundingClientRect().top <= line) cur = i; });
      if (lock >= 0) { if (Math.abs(scrollY - lockY) < 80 || settling) cur = lock; else lock = -1; }
      links.forEach((a, i) => { a.classList.toggle('is-on', i === cur); if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      if (railMQ.matches) {
        if (wrap.classList.contains('is-open')) setOpen(false, false);
        pill.classList.remove('is-shown');
        wrap.classList.toggle('is-rail', start.getBoundingClientRect().top <= 120 && endRail.getBoundingClientRect().top > 28 + panel.offsetHeight + 24);
      } else {
        wrap.classList.remove('is-rail');
        const show = bio.getBoundingClientRect().top > vh - 90;
        pill.classList.toggle('is-shown', show);
        if (!show && wrap.classList.contains('is-open')) setOpen(false, false);
      }
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', onScroll, {passive: true});
    addEventListener('resize', onScroll);
    update();

    // A shared link to a section (address ending in #heading) lands on that heading once the page has loaded.
    const fromHash = hs.findIndex(h => location.hash && decodeURIComponent(location.hash.slice(1)) === h.id);
    if (fromHash >= 0) addEventListener('load', () => jump(fromHash), {once: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
